import Vue from 'vue'
import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'

Vue.use(VXEUtils, XEUtils)



// WEBPACK FOOTER //
// ./src/utils/utils.js